import React, { useEffect } from 'react';
import useAnalytics from 'helpers/useAnalytics';
import { useParams } from 'react-router-dom';
import { useHistory } from 'react-router';
import { HOME_URL, ROLES_AND_PERMISSIONS_URL } from 'components/Router/consts';

import Page from 'components/Page/newComponents';
import Breadcrumbs from 'components/Page/Breadcrumbs';
import PageTitle from 'components/Page/PageTitle';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import DefaultRolesInfoCard from './molecules/DefaultRolesInfoCard';
import UsersTab from 'pages/RolesAndPermissions/tabs/UsersTab';
import RolesTab from 'pages/RolesAndPermissions/tabs/RolesTab';

const TAB_TYPES = {
  USERS: 'users',
  ROLES: 'roles',
};

function RolesAndPermissionsPage() {
  const history = useHistory();
  const analytics = useAnalytics();
  const { tab } = useParams<{ tab?: string }>();
  const currentTab = tab || TAB_TYPES.ROLES;

  useEffect(() => {
    document.title = 'Roles/Permissions';
  }, []);

  const handleTabChange = (tabValue: string) => {
    if (tabValue === 'users') {
      analytics.track('Roles/Permissions - User Tab Clicked', {
        category: 'AD - Roles/Permissions',
      });
    }
    history.push(`${HOME_URL}${ROLES_AND_PERMISSIONS_URL}/${tabValue}`);
  };

  const tabContentByType = {
    [TAB_TYPES.ROLES]: <RolesTab />,
    [TAB_TYPES.USERS]: <UsersTab />,
  };

  return (
    <Page>
      <Breadcrumbs routes={['Home']} />
      <PageTitle
        title="Roles/Permissions"
        subtitle="Manage roles and permissions to assign fine-grained access for viewing people, editing profiles, and viewing restricted attributes in your Directory and Org Chart."
      />

      <DefaultRolesInfoCard />

      <Tabs value={currentTab} onChange={(e, value) => handleTabChange(value)}>
        <Tab label="Roles" value={TAB_TYPES.ROLES} />
        <Tab label="Users" value={TAB_TYPES.USERS} />
      </Tabs>
      {tabContentByType[currentTab]}
    </Page>
  );
}

export default RolesAndPermissionsPage;
